import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Userback from "@userback/widget";
import App from './App.district';
import { appSettings } from '../../app-settings';
import { loadPunchlist } from './common/punchlist';
if (appSettings.USERBACK_KEY) {
    Userback(appSettings.USERBACK_KEY);
}
loadPunchlist();
createRoot(document.getElementById('root')).render(__DEV__ ? _jsx(StrictMode, { children: _jsx(App, {}) }) : _jsx(App, {}));
